
import {
  SOFTSEGUROS_VENDEDORES_GET_REQUEST,
  SOFTSEGUROS_VENDEDORES_GET_SUCCESS,
  SOFTSEGUROS_VENDEDORES_GET_ERROR,
} from 'Redux/types/softsegurosVendedoresTypes';

import { CALL_ACTIONS } from 'Redux/middleware';
import { BACKEND_URL_SOFTSEGUROS_VENDEDORES } from 'Config/routes';


const fetchSoftsegurosVendedoresAction = (data) => (
  {
    [CALL_ACTIONS]: {
      TYPES: [SOFTSEGUROS_VENDEDORES_GET_REQUEST, SOFTSEGUROS_VENDEDORES_GET_SUCCESS, SOFTSEGUROS_VENDEDORES_GET_ERROR],
      ENDPOINT: BACKEND_URL_SOFTSEGUROS_VENDEDORES,
      METHOD: 'GET',
      DATA: data,
    },
  });

const fetchSoftsegurosVendedores = (data = {}) => (dispatch) => dispatch(fetchSoftsegurosVendedoresAction(data));

export default fetchSoftsegurosVendedores;
